module.exports = __webpack_public_path__ + "media/images/mollie-4129bed450fc04dd2f49358ed084afb2.png";